import { render, staticRenderFns } from "./SaudeOcupacionalComponente.vue?vue&type=template&id=e51f051c&scoped=true"
import script from "./SaudeOcupacionalComponente.vue?vue&type=script&lang=js"
export * from "./SaudeOcupacionalComponente.vue?vue&type=script&lang=js"
import style0 from "./SaudeOcupacionalComponente.vue?vue&type=style&index=0&id=e51f051c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51f051c",
  null
  
)

export default component.exports